<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">Quản lý người dùng</div>
      </div>
      <div class="card card-w-title" v-if="display_page">
        <div class="box-top-list">
          <span class="p-m-0">{{ titleModel }}</span>
          <span class="right-button">
            <Button class="p-button-warning" :label="'Quay lại'" @click="backList" />
            <Button :disabled="submitForm" class="p-button-success btn-custom" :label="labelName" @click="saveData" />
          </span>
        </div>
        <div class="list-data">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="name">Tên tài khoản<span class="error">*</span></label>
                <InputText id="name" type="text" v-model="name" />
                <small v-if="validationErrors && validationErrors['name']"
                    class="p-invalid" >{{validationErrors['name']}}</small>
              </div>
            </div>

            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="organization_parent">Đơn vị cấp cha</label>
                <v-select :key="keyOrganizationParent"  :filterable="false" placeholder="Chọn đơn vị cấp cha" v-model="organization_parent"  :options="listParents" :reduce="listParents => listParents.value"  label="label" @input="changeOrganization"  @search="fetchOptionsOrganization">
                  <span slot="no-options" @click="$refs.select.open = false">
                  {{ $dataCommon.TEXT_NOT_FIND_DATA_SELECT }}
                </span>
                </v-select>
                <!--<Dropdown :key="keyOrganizationParent" @change="changeOrganization"  :filter="true" :showClear="true"  placeholder="Chọn đơn vị cấp cha" inputId="organization_parent" v-model="organization_parent" :options="listParents" optionLabel="label"  optionValue="value" />
              --></div>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="phone_number">Số điện thoại <span class="error">*</span></label>
                <InputText  id="phone_number" type="text" v-model="phone_number"/>
                <small v-if="validationErrors && validationErrors['phone_number']"
                    class="p-invalid" >{{validationErrors['phone_number']}}</small>
                <small v-if="phone_exists"
                class="p-invalid" >Số điện thoại bị trùng</small>
              </div>
            </div>

            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="organization_id">Đơn vị của tài khoản <span class="error">*</span></label><!--:filterable="false"-->
                <v-select :key="keyOrganization" :filterable="false"  placeholder="Chọn đơn vị" v-model="organization_id"  :options="listChilds" :reduce="listChilds => listChilds.value"  label="label" @input="changeOrganizationUser"    @search="fetchOptionsOrganizationChild">
                  <span slot="no-options" @click="$refs.select.open = false">
                  {{ $dataCommon.TEXT_NOT_FIND_DATA_SELECT }}
                </span>
                </v-select>
                <!--<Dropdown :key="keyOrganization"  @change="changeOrganizationUser" :filter="true"   placeholder="Chọn đơn vị" inputId="organization_id" v-model="organization_id" :options="listChilds" optionLabel="label"  optionValue="value" />
               --> <small v-if="validationErrors && validationErrors['organization_id']"
                    class="p-invalid" >{{validationErrors['organization_id']}}</small>
              </div>
            </div>
            
           
           
            
            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="email">Email</label>
                <InputText  id="email" type="text" v-model="email"/>
                <small v-if="validationErrors && validationErrors['email']"
                    class="p-invalid" >{{validationErrors['email']}}</small>
              </div>
            </div>

            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="status">Trạng thái hoạt động <span class="error">*</span></label>
                <Dropdown  inputId="status" v-model="status" :options="optionStatus" optionLabel="label"  optionValue="value" />
              </div>
            </div>

            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label class="group-label" for="user_level">Cấp bậc <span class="error">*</span><span :class="'icon-info ' + (checkEnable('level') ? 'selected' : '')" @click="showInfo('level')"><i class="pi pi-info"></i></span></label>
                <v-select :clearable="false" :filterable="false" placeholder="Chọn cấp bậc" v-model="user_level"  :options="usersLevel" :reduce="usersLevel => usersLevel.value"  label="label"   @search="fetchOptionsUserLevel">
                  <span slot="no-options" @click="$refs.select.open = false">
                  {{ $dataCommon.TEXT_NOT_FIND_DATA_SELECT }}
                </span>
                </v-select>
                <!--<Dropdown   :filter="true" placeholder="Chọn cấp bậc" inputId="user_level" v-model="user_level" :options="usersLevel" optionLabel="label"  optionValue="value" />
                --><small v-if="validationErrors && validationErrors['user_level']"
                    class="p-invalid" >{{validationErrors['user_level']}}</small>
              </div>
            </div>

            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8" ><!--v-if="checkVisible('users', 'active')"-->
                <label ></label>
                <div class="p-field-checkbox">
                  <Checkbox v-if="mode_page == 'add'" :disabled="!(is_management_units_check) " v-model="is_representative" :binary="true"/><!--!checkCompany()-->
                  <Checkbox v-else  v-model="is_representative" :binary="true"/><!--!checkCompany()-->
                  <label class="group-input-check">
                    <span>Tài khoản người đại diện</span>
                    <p>(Việc xác định tài khoản người đại diện để phục vụ cho việc quản lý nhân sự của Đơn vị cấp trên)</p>
                  </label>
                </div>
              </div>
            </div>

            <!-- <div class="p-field p-col-12 p-md-6" v-if="checkCompany()">
              <div class="p-col-8" v-if="checkVisible('users', 'active')">
                <label ></label>
                <div class="p-field-checkbox">
                  <Checkbox  v-model="is_representative" :binary="true"/>
                  <label class="group-input-check">
                    <span>Tài khoản người đại diện</span>
                    <p>(Việc xác định tài khoản người đại diện để phục vụ cho việc quản lý nhân sự của Đơn vị cấp trên)</p>
                  </label>
                </div>
              </div>
            </div>
            <div class="p-field p-col-12 p-md-6" v-else>
              <div class="p-col-8" v-if="checkVisible('users', 'active')">
                <label ></label>
                <div class="p-field-checkbox">
                  <Checkbox :disabled="true" v-model="is_representative" :binary="true"/>
                  <label class="group-input-check">
                    <span>Tài khoản người đại diện</span>
                    <p>(Việc xác định tài khoản người đại diện để phục vụ cho việc quản lý nhân sự của Đơn vị cấp trên)</p>
                  </label>
                </div>
              </div>
            </div> -->

            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label class="group-label" for="role_id">Quyền truy cập <span class="error">*</span><span :class="'icon-info '+ (checkEnable('role') ? 'selected' : '')" @click="showInfo('role')"><i class="pi pi-info"></i></span></label>

                <v-select :clearable="false" :filterable="false" placeholder="Chọn quyền truy cập" v-model="role_id"  :options="roles" :reduce="roles => roles.value"  label="label"   @search="fetchOptionsRoles">
                  <span slot="no-options" @click="$refs.select.open = false">
                  {{ $dataCommon.TEXT_NOT_FIND_DATA_SELECT }}
                </span>
                </v-select>
                <!--<Dropdown :filter="true" placeholder="Chọn quyền truy cập" inputId="role_id" v-model="role_id" :options="roles" optionLabel="label"  optionValue="value" />
               --> <small v-if="validationErrors && validationErrors['role_id']"
                    class="p-invalid" >{{validationErrors['role_id']}}</small>
              </div>
            </div>

            <div class="p-field p-col-12 p-md-6" v-if="hardcodeID == organization_id"><!--Check điều kiện đơn vị hòng ký mới hiển thị-->
              <div class="p-col-8" >
                <label ></label>
                <div class="p-field-checkbox">
                  <Checkbox v-model="is_management_units" :binary="true"/>
                  <label class="group-input-check">
                    <span>Quản lý dữ liệu tất cả các đơn vị</span>
                    <p>(Áp dụng cho Admin Hồng Ký quản lý dữ liệu tất các đơn vị)</p>
                  </label>
                </div>
              </div>
            </div>
            <div class="p-field p-col-12 p-md-12" v-if="mode_page == 'edit'">
              <div class="p-col-8" v-if="modelData.user_type == $dataCommon.USER.USER_TYPE.STAFF">
                <div class="box_change_role" @click="show_popup_change_role" >
                  <img class="img_change_role" :src="$dataCommon.IMAGE.ICON_CHANGE" />
                  <span class="title_change_role" >Đổi quyền khách hàng</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <Dialog
          class="dialog-comfirm-common"
          :visible.sync="showConfirmDialog"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
          :closable="true"
      >
        <div class="box_body_popup" >
          <div >
            <!--<div class="box_title_suceess"><img class="img_noti" :src="check_success_img" /><span class="title_noti" style="">Thành công</span></div>
           -->
            <p class="p_title_1" style="text-align: left">Tài khoản sau khi đổi quyền thì khi truy cập vào hệ thống Mobile App như khách hàng bình thường.</p>
            <p class="p_title_1" style="text-align: left;">Bạn có đồng ý chuyển quyền truy cập của nhân viên này thành khách hàng  không?</p>
            <div class="box_btn">
              <div class="p-grid">
                <div class="p-col-6" style="text-align: right">
                  <Button
                      @click="change_role_user"
                      style="width: 100px;"
                      iconPos="right"
                      class="btn-custom"
                      :label="'Đồng ý'"
                      type="button"
                  > </Button><!--@click="redirect_ToHistory"-->
                </div>
                <div class="p-col-6" style="text-align: left">
                  <Button
                      style="width: 100px;"
                      iconPos="right"
                      class="btn-custom p-button-danger"
                      :label="'Hủy'"
                      type="button"
                      @click="cancel_popup"
                  > </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <template #header>
          <div>
            <span class="title-confirm" >Xác nhận</span>
            <!--<span class="description-confirm">asdasdas</span>-->
          </div>
        </template>
      </Dialog>
    </div>
    <Dialog 
      :header="'Chú thích'"
      :visible.sync="displayDialog"
      :contentStyle="{overflow: 'visible'}"
      :style="{width: '30vw'}"
      :class="'popup-confirm'"
      :modal="true"
      >
      <div class="content-confirm">
          <p class="text-description" v-html="description"></p>
      </div>
    </Dialog>
  </div>
</template>

<script>
import Api from '@/services'
import DataServices from '@/core/DataServices'
export default {
  data() {
    return {
      modelData: [],
      dataModel: null,
      componentKey: 0,
      modelName: 'users',
      titleModel: 'Tạo mới tài khoản',
      is_enabled: true,
      name: '',
      phone_number: '',
      email: '',
      roles: [],
      role_id: null,
      usersLevel: [],
      user_level: null,
      organization_id: null,
      organization_parent: null,
      listParents: [],
      listChilds: [],
      listChildsTmp: [],
      validationErrors: {},
      phone_exists: false,
      submitForm: false,
      optionStatus: [{value: 0, label: 'Ngưng hoạt động'}, {value: 1, label: 'Đang hoạt động'} ],
      status: 1,
      displayDialog: false,
      description: '',
      is_representative: false,
      is_management_units: false,
      is_management_units_check: false,
      organization_user: 0,
      organization_user_parent: 0,
      hardcodeID: 0,
      displayDialogWarrning: false,
      message_warnning: 'Đơn vị đã tạo {0} tài khoản. Vui lòng kiểm tra lại',
      labelName: 'Tạo',
      keyOrganizationParent: Math.random() * 10,
      keyOrganization: Math.random() * 110,
      display_page:true,
      mode_page:'add',
      showConfirmDialog:false
    }
  },
  async mounted () {
    //this.showConfirmDialog = true
    var vm = this;
    var organization = this.$myConstants.organizationUserLogin();
    var creator_organization_id = (!this.$myConstants.isEmpty(organization.id)) ? organization.id:null;
    await this.settingsHardCode();
    this.listParents = await this.getOrganizationNormal();
    this.roles = await this.getRoles();
    this.usersLevel = await this.getUserLevel();
    this.dataModel = DataServices.getModel(this.modelName);
    if (this.$route.params.id !== undefined && !isNaN(this.$route.params.id)) {
      if (!vm.$myConstants.checkRoleGroup('users', 'edit')){
        vm.display_page = false;
      }
      this.titleModel = 'Chỉnh sửa tài khoản';
      await this.getData(Number(this.$route.params.id));
      await this.getUsers(this.organization_id);
      this.mode_page = 'edit';
    }else {
      if (!vm.$myConstants.checkRoleGroup('users', 'add')){
        vm.display_page = false;
      }
    }
    await this.getOrganizationUser();
    //Phân quyền dữ liệu
    this.is_management_units_check = false;
    if (parseFloat(this.hardcodeID) ==  creator_organization_id){
      if (!this.$myConstants.isEmpty(this.$store.getters.fullname.is_management_units)){
        if (this.$store.getters.fullname.is_management_units == true){
          this.is_management_units_check = true;
        }
      }
    }
    // this.is_enabled = this.checkVisible('users', 'active');
  },
  methods: {
    async cancel_popup(){
      this.showConfirmDialog = false;
    },
    async show_popup_change_role(){
      this.showConfirmDialog = true;
    },
    async change_role_user(){
      var vm = this;
      this.$store.commit('setDataLoading', {content: 'Đang lưu dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      if (!this.$myConstants.isEmpty(this.$route.params.id)){
        var where = {
          id:  {_eq: this.$route.params.id}
        };
        var user =await DataServices.getObjectData('users',where,{id: 'desc'});
        if (!this.$myConstants.isEmpty(user)){
          if (user.user_type == this.$dataCommon.USER.USER_TYPE.STAFF){
            var params = {
              'user_type': this.$dataCommon.USER.USER_TYPE.CUSTOMER,
              'modified_date': this.$myConstants.currentDate(),
            }
            //await DataServices.updateData('users', {"variables": JSON.stringify({data_update: params, where_key: { id: {'_eq': this.modelData.user_id }}})});
            var list_upsert_customer = [];
            var data_customer = {
              'user_id':(!this.$myConstants.isEmpty(this.$route.params.id)) ? this.$route.params.id:'',
              'full_name':(!this.$myConstants.isEmpty(user.full_name)) ? user.full_name:'',
              'phone_number': (!this.$myConstants.isEmpty(user.phone_number)) ? user.phone_number:'',
              'email': (!this.$myConstants.isEmpty(user.email)) ? user.email:'',
              'customer_type': 1,
              status: 1,
            };
            var whereCustomer = {
              user_id:  {_eq: this.$route.params.id}
            };
            var customer =await DataServices.getObjectData('customer',whereCustomer,{id: 'desc'});
            console.log("customercustomer:",customer)
            if (!this.$myConstants.isEmpty(customer)){
            if (!this.$myConstants.isEmpty(customer.id)) {
              data_customer.id = customer.id;
            }
            }
            list_upsert_customer.push(data_customer);
           var queryUpsertCustomer = `
          insert_core_customer_profile (
              objects: $core_customer_profile_upsert,
              on_conflict: {
                constraint: core_customer_profile_pkey,
                update_columns: [full_name,phone_number,phone_number,email,customer_type,status]
                }
              ) {
            returning {
              id
            }
          }
          `;

            var queryUpdateUser = `
        mutation update_data($core_user_object: core_user_set_input,$core_customer_profile_upsert:[core_customer_profile_insert_input!]!) {
          update_core_user(where: { id: {_eq: "${this.$route.params.id}"}}, _set: $core_user_object) {
            affected_rows
            returning {
              id
            }
          }
          ${queryUpsertCustomer}
        }
          `;
            var variablesUpdateUser = {
              "variables": JSON.stringify({
                core_user_object: params,
                core_customer_profile_upsert: list_upsert_customer,
              })
            };
            await DataServices.executeQuery('users', queryUpdateUser, variablesUpdateUser).then(async () => {
              vm.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Đổi quyền khách hàng thành công', life: 3000 });
              vm.$router.push({path: '/admin/users'});
            }).catch(async (err) => {
              console.log("errerrerrerrerrerrerr:",err)
              vm.$toast.add({
                severity: 'error',
                summary: 'Thông báo',
                detail: 'Hệ thống đã gặp sự cố !Xin vui lòng thử lại.',
                life: 3000
              });
            });
            this.$store.commit('setLoading', false);
            return false;
          }else {
            this.$store.commit('setLoading', false);
            this.$toast.add({
              severity: 'error',
              summary: 'Thông báo',
              detail: 'Hệ thống đã gặp sự cố !Xin vui lòng thử lại.',
              life: 3000
            });
            return false;
          }
        }
        this.$toast.add({
          severity: 'error',
          summary: 'Thông báo',
          detail: 'Hệ thống đã gặp sự cố !Xin vui lòng thử lại.',
          life: 3000
        });
        this.$store.commit('setLoading', false);
      }

    },
    checkEnable(name) {
      if (name == 'role' && this.role_id > 0) {
        var returnRole  = this.roles.filter(a => a.value == this.role_id);
        if (returnRole && Object.keys(returnRole).length) {
          return (returnRole[0].item.description != undefined  &&  returnRole[0].item.description != null) ? returnRole[0].item.description.length > 0 : false;
        }
      } else if (name == 'level' && this.user_level > 0) {
        var returnData  = this.usersLevel.filter(a => a.value == this.user_level);
        if (returnData && Object.keys(returnData).length) {
          return (returnData[0].item.description != undefined  &&  returnData[0].item.description != null) ? returnData[0].item.description.length > 0 : false;
        }
      }
      return false;
    },
    showInfo(name) {
      if (name == 'role' && this.checkEnable(name)) {
        var returnRole  = this.roles.filter(a => a.value == this.role_id);
        if (returnRole && Object.keys(returnRole).length) {
          this.displayDialog = true;
          this.description = '<span>Quyền truy cập: <abbr>' + returnRole[0].label + '</abbr></span>';
          this.description += (returnRole[0].item.description != undefined  &&  returnRole[0].item.description != null) ? returnRole[0].item.description : '';
        }
      } else if (name == 'level' && this.checkEnable(name)) {
        var returnData  = this.usersLevel.filter(a => a.value == this.user_level);
        if (returnData && Object.keys(returnData).length) {
          this.displayDialog = true;
          this.description = '<span>Cấp bậc: <abbr>' + returnData[0].label + '</abbr></span>';
          this.description += (returnData[0].item.description != undefined  &&  returnData[0].item.description != null) ? returnData[0].item.description : '';

        }
      }
    },
    checkVisible(groupName, action) {
      return this.$myConstants.checkVisible(this.$store.getters.permission, groupName, action);
    },
    async getData(id) {
      var variables = {
        where_key: {
          id: {'_eq': id }
        }
      }

     
      var data = await DataServices.getList(this.modelName, {"variables": JSON.stringify(variables), "fields": "id user_type full_name phone_number email is_enabled is_representative is_management_units user_level_id roles { role_id } organization_account { organization_id organization { parent_id } }"});
      var list = data[Object.keys(data)];
      if (list != null && Object.keys(list).length) {
        var model = list[0];
        this.modelData = model;
        this.labelName = 'Lưu';
        if(model.full_name != undefined) this.name = model.full_name;
        if(model.phone_number != undefined && model.phone_number != '') {
          var phone_convert = model.phone_number;
          this.phone_number = phone_convert.replace('+84', '0');
        }
        
        if(model.email != undefined) this.email = model.email;
        if(model.is_enabled != undefined) this.status = model.is_enabled ? 1 : 0;
        if(model.user_level_id != undefined) this.user_level = model.user_level_id;
        if(model.is_management_units != undefined) this.is_management_units = model.is_management_units;
        if(model.roles != undefined && model.roles != null && model.roles.role_id != undefined && model.roles.role_id != null) this.role_id = model.roles.role_id ;
        if(model.organization_account != undefined && model.organization_account != null && model.organization_account.organization != undefined && model.organization_account.organization != null ) {
         
          if(model.organization_account != undefined && model.organization_account != null && model.organization_account.organization != undefined && model.organization_account.organization != null &&
          model.organization_account.organization.parent_id != undefined && model.organization_account.organization.parent_id != null) {
            this.organization_parent = model.organization_account.organization.parent_id ;
          }

          if(model.organization_account != undefined && model.organization_account != null && model.organization_account.organization_id != undefined && model.organization_account.organization_id != null)  {
            this.organization_id = model.organization_account.organization_id;
          }
        }

        this.keyOrganizationParent = Math.random() * 10;
        this.keyOrganization = Math.random() * 110;
        this.is_representative = this.modelData.is_representative;
        this.componentKey++;
      }
    },
    backList() {
      this.$router.push({path: '/admin/users'});
    },
    async fetchOptionsUserLevel (search, loading) {
      console.log(loading);
      if (!this.$myConstants.isEmpty(search)){
        var whereAttact = {plain_name:{_like: "%"+this.$myConstants.SkipVN(search).trim()+"%"}};
        this.usersLevel =await this.getUserLevel(whereAttact);
      }else {
        this.usersLevel = await this.getUserLevel();
      }
    },
    async getUserLevel(whereAttach = null) {
      var whereKey = {
        status: {'_eq': 1}
      }
      if (whereAttach){
        for (const [key, value] of Object.entries(whereAttach)) {
          whereKey[key] = value;
        }
      }
      var variables = {
        where_key: whereKey
      }

      var data = await DataServices.getList('view_user_level', {"variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];
      var usersLevel =[];
      if (list && Object.keys(list).length) {
        for (let index = 0; index < list.length; index++) {
          var item = list[index];
          usersLevel.push({label: item.name, value: item.id, item: item});
        }
      }
      return usersLevel;
    },
    checkCompany() {
      var organization = this.$myConstants.organizationUserLogin();
      var checkLevel = this.$myConstants.managementLevel();
      var levelParent = this.$myConstants.levelParent();
      if (organization && Object.keys(organization).length) {
        this.organization_user = organization.id;
        this.organization_user_parent = (organization.parent_id != undefined && organization.parent_id != null) ? organization.parent_id : 0;
      }
      if (this.hardcodeID > 0 && this.organization_user > 0 && this.organization_user == this.hardcodeID 
      && checkLevel && levelParent == 0) return true;
      return false;
    },
    async fetchOptionsRoles (search, loading) {
      console.log(loading);
      if (!this.$myConstants.isEmpty(search)){
        var whereAttact = {plain_name:{_like: "%"+this.$myConstants.SkipVN(search).trim()+"%"}};
        this.roles =await this.getRoles(whereAttact);
      }else {
        this.roles = await this.getRoles();
      }
    },
    async getRoles(whereAttach = null) {
      var organization = this.$myConstants.organizationUserLogin();
      var creator_organization_id = (!this.$myConstants.isEmpty(organization.id)) ? organization.id:null;
      var id_organization_hong_ky =await this.$coreService.id_organization_hong_ky();

      var whereKey = {
        status: {'_eq': 1}
      }

      var is_management_units = false;
      if (parseFloat(id_organization_hong_ky) ==  creator_organization_id){
        if (!this.$myConstants.isEmpty(this.$store.getters.fullname.is_management_units)){
          if (this.$store.getters.fullname.is_management_units == true){
            is_management_units = true;
          }
        }
      }

      if (is_management_units == true){
        whereKey = {
          status: {'_in': [0, 1]}
        }
      }

      /*if (this.checkCompany()) {
        whereKey = {
          status: {'_in': [0, 1]}
        }
      }*/

      /*if (this.$store.getters.role != undefined && this.$store.getters.role != null) {
        var roleID = (this.$store.getters.role.role_id != undefined && this.$store.getters.role.role_id != null) ? this.$store.getters.role.role_id: 0;
        if (roleID  > 0) {
          whereKey = {
            _or: [
              {id: {'_eq': roleID} },
              whereKey
            ]
          }
        }
      }*/
      // console.log('whereKey', whereKey);

      if (whereAttach){
        for (const [key, value] of Object.entries(whereAttach)) {
          whereKey[key] = value;
        }
      }
      var variables = {
        where_key: whereKey
      }

      var data = await DataServices.getList('view_role', {"variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];
      var list_role = [];
      if (list && Object.keys(list).length) {
        for (let index = 0; index < list.length; index++) {
          var item = list[index];
          
          //this.roles.push({label: item.name, value: item.id, item: item});
          list_role.push({label: item.name, value: item.id, item: item});
        }
      }
      return list_role;
    },
    
    async checkPhoneNumber() {
      this.phone_number = this.phone_number.trim();
      if (this.phone_number !== undefined && this.phone_number !== "") {
        var phone_convert = this.$myConstants.replaceAt(this.phone_number, 0, '+84');
        var where = {
          phone_number: {'_ilike': phone_convert},
          //status: {'_in': [1] },
        }
        if (this.modelData != null && this.modelData.id != undefined && this.modelData.id != null && this.modelData.id > 0) where = Object.assign(where, {id: {'_neq': this.modelData.id}})
        var data = await DataServices.getList(this.modelName, {"fields": "id status phone_number", "variables": JSON.stringify({where_key: where})});
        if (data[Object.keys(data)].length > 0){
          var list_user_check = data[Object.keys(data)];
          var item_user = list_user_check[0];
          if (item_user){
            if (parseFloat(item_user.status) == 2){
              var user_id = (item_user.id)  ? item_user.id:0;
              var phone_number = (item_user.phone_number)  ? item_user.phone_number:'';
              await this.$coreService.updateCustomerDelete(user_id,phone_number);
              return false;
            }
          }
        }
        return data && data[Object.keys(data)].length > 0
      }
    },
    
    async validationData() {
      this.validationErrors = {};
      this.phone_exists = false;
      this.phone_number = this.phone_number.trim();
      if (this.name == undefined || this.name == '') this.validationErrors['name'] = 'Nhập tên tài khoản';
      if (this.phone_number == '' || this.phone_number.length == 0){
        this.validationErrors['phone_number'] = 'Nhập số điện thoại';
      }else {
        if (!this.$myConstants.validatePhone(this.phone_number,10)){
          this.validationErrors['phone_number'] = 'Nhập không đúng định dạng số điện thoại di động';
        }else {
          this.phone_exists = await this.checkPhoneNumber();
        }
      }
      //if (this.phone_number != '' && (this.phone_number.length != 10 || isNaN(this.phone_number))) this.validationErrors['phone_number'] = 'Nhập số điện thoại không đúng định dạng';
      if (this.email != undefined && this.email != null && this.email != '' && !this.$myConstants.mailValidation(this.email)) this.validationErrors['email'] = 'Email không đúng định dạng';
      if(this.role_id == undefined || this.role_id == 0) this.validationErrors['role_id'] = 'Chọn quyền truy cập';
      if(this.user_level == undefined || this.user_level == 0) this.validationErrors['user_level'] = 'Chọn cấp bậc';
      if(this.organization_id == undefined || this.organization_id == 0) this.validationErrors['organization_id'] = 'Chọn đơn vị của tài khoản';

    },
    async insertUpdateRole(userID) {
      var tableName = 'user_role';
      var variables = {
        where_key: {
          user_id: {'_eq': userID}
        }
      }
      var data = await DataServices.getList(tableName, {"variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];
      if (list && Object.keys(list).length) {
        await DataServices.updateData(tableName, {"variables": JSON.stringify({data_update: {role_id: this.role_id, modified_date: this.$myConstants.currentDate()}, where_key: { user_id: {'_eq': userID }}})});
      } else {
        var params = {
          role_id: this.role_id,
          user_id: userID,
          created_date: this.$myConstants.currentDate(),
          modified_date: this.$myConstants.currentDate(),
          status: 1
        }
        await DataServices.insertData(tableName, {"variables": JSON.stringify({objects: params})});
      }
    },
    async insertUpdateOrganizationAccount(userID) {
      var tableName = 'organization_account';
      var variables = {
        where_key: {
          user_id: {'_eq': userID}
        }
      }
      var data = await DataServices.getList(tableName, {"variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];
      if (list && Object.keys(list).length) {
        await DataServices.updateData(tableName, {"variables": JSON.stringify({data_update: {organization_id: this.organization_id, modified_date: this.$myConstants.currentDate()}, where_key: { user_id: {'_eq': userID }}})});
      } else {
        var params = {
          organization_id: this.organization_id,
          user_id: userID,
          created_date: this.$myConstants.currentDate(),
          modified_date: this.$myConstants.currentDate(),
          status: 1
        }
        await DataServices.insertData(tableName, {"variables": JSON.stringify({objects: params})});
      }
    },

    async saveData() {
      this.submitForm = true;
      await this.validationData();
      if (!this.phone_exists && !this.tax_number_exists && Object.entries(this.validationErrors).length === 0) {
        this.$store.commit('setDataLoading', {content: 'Đang lưu dữ liệu', icon: true});
        this.$store.commit('setLoading', true);
        var phone_convert = '';
        if (this.phone_number.length == 10) {
          phone_convert = this.$myConstants.replaceAt(this.phone_number, 0, '+84');
        }
        var params = {
          'full_name': (!this.$myConstants.isEmpty(this.name)) ? this.$myConstants.capitalizeFirst(this.name):'',
          'email': this.email,
          'phone_number': phone_convert,
          'user_level_id': this.user_level,
          'is_enabled': this.status > 0
        }
        if (this.organization_id == this.hardcodeID){
          params.is_management_units = this.is_management_units;
        }else {
          params.is_management_units = null;
        }
        var total = this.$myConstants.organizationCountUser();
        if (this.organization_id != this.organization_user) {
          var variablesCheck = {
            where_key: {
              status: {'_eq': 1},
              id: {'_eq': this.organization_id}
            }
          }
          var dataCheck = await DataServices.getList('organization', {"variables": JSON.stringify(variablesCheck)});
          var listCheck = dataCheck[Object.keys(dataCheck)];
          if (listCheck && Object.keys(listCheck).length) {
            total = (listCheck[0].number_of_accounts != undefined && listCheck[0].number_of_accounts != null) ? listCheck[0].number_of_accounts : 0;
          }
        }
        
        var count  = await this.getUsers(this.organization_id);
        this.message_warnning = this.message_warnning.replace('{0}', count + '/' + total);
        if (this.modelData != null && this.modelData.id != undefined && this.modelData.id != null && this.modelData.id > 0) {
          var statusTmp = this.modelData.is_enabled ? 1 : 0;
          if (this.status == 0) {
            await this.updateUsers(params);
              //update status token về  0
              var updateStatusToken = {
                status: 0
              }
              DataServices.updateData('user_token', {"variables": JSON.stringify({data_update: updateStatusToken, where_key: { user_id: {'_eq': this.modelData.id },status: {'_eq': 1 }}})});
          } else {
            var organizationEdit = 0;
            if(this.modelData.organization_account != undefined && this.modelData.organization_account != null && this.modelData.organization_account.organization_id != undefined && this.modelData.organization_account.organization_id != null)  {
              organizationEdit = this.modelData.organization_account.organization_id;
            }
            if (organizationEdit > 0 && (this.organization_id == organizationEdit && ((this.status == 1 && this.status != statusTmp && count >= total) || count > total)) || ( this.organization_id !== organizationEdit && count >= total)) {
              this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: this.message_warnning, life: 3000 })
              this.$store.commit('setLoading', false);
              this.submitForm = false;
            } else {
              if (!this.is_representative) {
                await this.updateUsers(params);
              } else {
                // check tài khoản người đại diện
                if (await this.checkOrganizationRepresentative(this.organization_id)) {
                  this.$toast.add({ severity: 'warn', summary: 'Thông báo', detail: 'Đại lý bạn chọn đã có tài khoản người đại diện. Vui lòng kiểm tra lại.', life: 3000 })
                  this.$store.commit('setLoading', false);
                  this.submitForm = false;
                } else await this.updateUsers(params);
              }
            }
          }
        }
        else {
          console.log("AAAAAAA:",this.is_representative);
          if (count >= total) {
            this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: this.message_warnning, life: 3000 })
            this.$store.commit('setLoading', false);
            this.submitForm = false;
          } else {
            //nếu thoả điều kiện user root
            if (this.checkCompany()) {
              console.log("111");
              // uncheck tài khoản người đại diện
              console.log("111:",this.is_representative);
              if (!this.is_representative) {
                await this.addUsers(params);
              }
              // check tài khoản người đại diện
              else{
                if (await this.checkOrganizationRepresentative(this.organization_id)) {
                  console.log("333333333:",this.organization_id);
                  this.$toast.add({ severity: 'warn', summary: 'Thông báo', detail: 'Đại lý bạn chọn đã có tài khoản người đại diện. Vui lòng kiểm tra lại.', life: 3000 })
                  this.$store.commit('setLoading', false);
                  this.submitForm = false;
                } else await this.addUsers(params);
              }
            } else {
              console.log("222");
              if (this.organization_id == this.organization_user) {
                await this.addUsers(params);
              } else {
                console.log("55555555:",this.organization_id);
                console.log("this.is_representative:",this.is_representative);
                if (!this.is_representative) {
                  await this.addUsers(params);
                }else {
                  // check tài khoản người đại diện
                  if (await this.checkOrganizationRepresentative(this.organization_id)) {
                    this.$toast.add({
                      severity: 'warn',
                      summary: 'Thông báo',
                      detail: 'Đại lý bạn chọn đã có tài khoản người đại diện. Vui lòng kiểm tra lại.',
                      life: 3000
                    })
                    this.$store.commit('setLoading', false);
                    this.submitForm = false;
                  } else await this.addUsers(params);
                }
              }
            }
          }
        }
      } else this.submitForm = false;
    },
    //kiểm tra đơn vị có người đại diện
    async checkOrganizationRepresentative(organizationID) {
      var objUsers = {is_representative: {'_eq': true}, is_enabled: {'_eq': true}, status: {'_eq': 1}};
      if (this.modelData != undefined && this.modelData != null) {
        objUsers = Object.assign(objUsers,  {id: {'_neq': this.modelData.id}});
      }
      var whereKey = {
        id: {'_eq': organizationID},
        status: {'_eq': 1},
        organization_account: {
          organization_id: {'_eq': organizationID},
          user: objUsers
        }
      }
      var variables = {
        where_key: whereKey
      }
      var data = await DataServices.getList('organization', {"variables": JSON.stringify(variables)});
      console.log("checkOrganizationRepresentative:",data);
      var array = data[Object.keys(data)];
      return (Array.isArray(array) && array.length) > 0;
    },

    async updateUsers(params) {
      params = Object.assign(params, { 'modified_date': this.$myConstants.currentDate() })
      params = Object.assign(params, { 'is_representative': this.is_representative > 0 });
      await DataServices.updateData(this.modelName, {"variables": JSON.stringify({data_update: params, where_key: { id: {'_eq': this.modelData.id }}})});

      await this.insertUpdateRole(this.modelData.id);
      await this.insertUpdateOrganizationAccount(this.modelData.id);

      this.$store.commit('setLoading', false);
      this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Cập nhật thành công', life: 3000 })
      setTimeout(() => {
        this.$router.push({path: '/admin/users'});
      }, 500);
    },

    async addUsers(params) {
      var organization = this.$myConstants.organizationUserLogin();
      var creator_organization_id = (!this.$myConstants.isEmpty(organization.id)) ? organization.id:null;
      params = Object.assign(params, { 'is_phone_verified': false })
      params = Object.assign(params, { 'is_enabled': true })
      params = Object.assign(params, { 'is_blocked': false })
      params = Object.assign(params, { 'user_type': 2 })
      params = Object.assign(params, { 'status': 1 });
      params = Object.assign(params, { 'creator_id': this.$store.getters.fullname.id });
      params = Object.assign(params, { 'creator_organization_id': creator_organization_id });
      params = Object.assign(params, { 'is_representative': this.is_representative > 0 });
      params = Object.assign(params, { 'creator_id': this.$store.getters.fullname.id });
      params = Object.assign(params, { 'created_date': this.$myConstants.currentDate() })
      params = Object.assign(params, { 'modified_date': this.$myConstants.currentDate() })
      var returnData = await DataServices.insertData(this.modelName, {"variables": JSON.stringify({objects: params})});
      var userID = 0;
      if (returnData != null) {
        var checkData = returnData[Object.keys(returnData)];
        if (checkData.affected_rows) userID = checkData.returning[0].id;
      }

      if (userID > 0) {
        await this.insertUpdateRole(userID);
        await this.insertUpdateOrganizationAccount(userID);
      }

      // tạo token khi thêm tài khoản
      var payloadData = {user_id: userID}; 
      await Api.post('/auth/update-token', payloadData);

      this.$store.commit('setLoading', false);
      this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Tạo mới thành công', life: 3000 })
      setTimeout(() => {
        this.$router.push({path: '/admin/users'});
      }, 500);
    },

    async changeOrganizationUser($event) {
      if ($event.value && Number($event.value) > 0) {
        this.listParents = [];
        var dataSelected = this.listChilds.filter(a => a.value == Number($event.value));
        if (dataSelected && Object.keys(dataSelected).length) {
          if (dataSelected[0].parentID != undefined && dataSelected[0].parentID != null && Number(dataSelected[0].parentID) > 0) {
            this.organization_parent = dataSelected[0].parentID;
            if (this.organization_parent > 0) await this.getOrganization();
          }
        }
      } else {
        this.listParents = [];
        this.listParents = await this.getOrganizationNormal();
      }
      this.is_representative = ( this.organization_user != this.organization_id) ? true : false;
    },

    async changeOrganization() {
      this.organization_id = 0;
      this.listChilds = [];
      if (this.organization_parent && Number(this.organization_parent) > 0) {
        await this.organizationUserCurrent(Number(this.organization_parent));
      } else {
        this.listParents = [];
        this.listParents = await this.getOrganizationNormal();
        if (this.checkCompany()) {
          var variables = {
            where_key: {
              status: {'_eq': 1}
            }
          }
          var data = await DataServices.getList('organization', {"variables": JSON.stringify(variables)});
          var list = data[Object.keys(data)];
          if (list && Object.keys(list).length) {
            for (let index = 0; index < list.length; index++) {
              var item = list[index];
              var parentID = ((item.parent_id != undefined && item.parent_id != null) ? item.parent_id : null);
              this.listChilds.push({label: item.name, value: item.id, parentID: parentID});
            }
          }

          this.listChildsTmp = this.listChilds;
        } else {
          await this.organizationUserCurrent(this.organization_user, false);
        }
      }
    },
    // lấy đơn vị tài khoản
    async getOrganizationUser() {
      if (this.checkCompany()) {
        var variables = {
          where_key: {
            status: {'_eq': 1}
          }
        }
        var data = await DataServices.getList('organization', {"variables": JSON.stringify(variables)});
        var list = data[Object.keys(data)];
        if (list && Object.keys(list).length) {
          for (let index = 0; index < list.length; index++) {
            var item = list[index];
            var parentID = ((item.parent_id != undefined && item.parent_id != null) ? item.parent_id : null);
            this.listChilds.push({label: item.name, value: item.id, parentID: parentID});
          }
        }
        this.listChildsTmp = this.listChilds;
      } else {
        await this.organizationUserCurrent(this.organization_user, false);
      }
      if (this.organization_id == 0) this.organization_id = this.organization_user;
      if (this.organization_parent == 0 && this.organization_user !=  this.organization_user_parent) this.organization_parent = this.organization_user_parent;
    },
    //lấy danh sách đơn vị cấp cha khi lưa chọn
    async getOrganization() {
      var whereKey = {  status: {'_eq': 1}}
      if (!this.checkCompany()) {
        whereKey = Object.assign(whereKey, {id: {'_in': [this.organization_parent]}});
      }
      var variables = {
        where_key: whereKey
      }
      var data = await DataServices.getList('organization', {"variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];
      if (list && Object.keys(list).length) {
        for (let index = 0; index < list.length; index++) {
          var item = list[index];
          var parentID = ((item.parent_id != undefined && item.parent_id != null) ? item.parent_id : null);
          this.listParents.push({label: item.name, value: item.id, parentID: parentID});
        }
      }
    },


    async fetchOptionsOrganizationChild (search, loading) {
      console.log(loading);
      if (!this.$myConstants.isEmpty(search)){
        var list_child = [];
        var search_convert = this.$myConstants.SkipVN(search).trim();
        for (var i=0;i<this.listChildsTmp.length;i++){
          var textSearch = this.$myConstants.SkipVN(this.listChildsTmp[i].label);
          var keySearch = textSearch.search(search_convert);
          if (keySearch > -1){
            list_child.push(this.listChildsTmp[i]);
          }
        }
        this.listChilds =list_child;
      }else {
        this.listChilds = this.listChildsTmp;
      }
      //console.log(this.listChilds)
      return false;
    },
    async fetchOptionsOrganization (search, loading) {
      console.log(loading);
      if (!this.$myConstants.isEmpty(search)){
        var whereAttact = {plain_name:{_like: "%"+this.$myConstants.SkipVN(search).trim()+"%"}};
        this.listParents =await this.getOrganizationNormal(whereAttact);
      }else {
        this.listParents = await this.getOrganizationNormal();
      }
    },
    //lấy danh sách đơn vị cấp cha
    async getOrganizationNormal(whereAttach = null) {
      var whereKey = {status: {'_eq': 1}}
      if (!this.checkCompany()) {
        if (this.organization_user_parent > 0) {
          var arrOrganization = [this.organization_user];
          if(this.organization_user_parent != null) {
            arrOrganization.push(this.organization_user_parent);
          }
          whereKey = Object.assign(whereKey, {id: {'_in': arrOrganization}});
        } else {
          whereKey = Object.assign(whereKey, {id: {'_in': [this.organization_user]}});
        }
      }
      if (whereAttach){
        for (const [key, value] of Object.entries(whereAttach)) {
          whereKey[key] = value;
        }
      }
      var variables = {
        where_key: whereKey
      }
      var data = await DataServices.getList('view_organization', {"variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];
      var listParents = [];
      if (list && Object.keys(list).length) {
        for (let index = 0; index < list.length; index++) {
          var item = list[index];
          var parentID = ((item.parent_id != undefined && item.parent_id != null) ? item.parent_id : null);
          listParents.push({label: item.name, value: item.id, parentID: parentID});
          //this.listParents.push({label: item.name, value: item.id, parentID: parentID});
        }
      }
      return listParents;
    },
    // lấy đơn vị của user đăng nhập
    async organizationUserCurrent(organizationParent, isParent = true) {
      var whereKey = {
        status: {'_eq': 1}
      }
      // if (!this.checkCompany()) {
      if (isParent) {
        whereKey = Object.assign(whereKey, {parent_id: {'_in': [organizationParent]}})
      } else {
        
        var arrOrganization = [organizationParent];
        if (this.organization_id !== null) {
          arrOrganization.push(this.organization_id);
        }
        whereKey = Object.assign(whereKey, {
          _or: [
            {id: {'_in': arrOrganization} },
            {organization_account: {
              organization: {
                parent_id: {"_eq": organizationParent},
                creator_id: {"_eq": this.$store.getters.fullname.id}
              },
              user: { is_representative: {'_eq': false}, is_enabled: {'_eq': true}, status: {'_eq': 1}  }
            }}, 
            {organization_account: {
              organization: {
                parent_id: {"_eq": organizationParent},
                creator_id: {"_eq": this.$store.getters.fullname.id}
              },
              user: {is_representative: {'_eq': true}, is_enabled: {'_eq': false}, status: {'_neq': 1}}}
            }
          ]
        });
      }
      var variables = {
        where_key: whereKey
      }
      var data = await DataServices.getList('organization', {"variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];
      if (list && Object.keys(list).length) {
        // this.listChilds.push({label: 'Đơn vị của tôi', value: '', parentID: '', disabled: true});
        
        for (let index = 0; index < list.length; index++) {
          var item = list[index];
          var parentID = ((item.parent_id != undefined && item.parent_id != null) ? item.parent_id : null);
          this.listChilds.push({label: item.name, value: item.id, parentID: parentID});
        }
      }
      if (isParent) {
        this.listChilds =this.listChilds.filter(a => a.value != organizationParent);
      }
      if (this.listChilds && this.listChilds.length) {
        var resultPush = this.listChilds.reduce((unique, o) => {
          if(!unique.some(obj => obj.value === o.value)) {
            unique.push(o);
          }
          return unique;
        },[]);
        this.listChilds = resultPush;
      }
      this.listChildsTmp = this.listChilds;
    },
    // lấy đơn vị hardcode root
    async settingsHardCode() {
      var whereKey = {
        key: {'_eq': 'ORGANIZATION_ROOT' }
      }
      var variables = {
        where_key: whereKey
      }
      var data = await DataServices.getList('settings', {"variables": JSON.stringify(variables), "fields": "value"});
      var list = data[Object.keys(data)];
      if (list !== undefined && list !== null && Object.keys(list).length) {
        this.hardcodeID = list[0].value;
      }
    },
    // lấy tài khoản thuộc đơn vị và đang hoạt động
    async getUsers(organizationID) {
      var count = 0;
      var variables = {
        where_key: {
          organization_id: {'_eq': organizationID },
          user: {
            status: {"_eq": 1},
            user_type: {"_gt": 1},
            is_enabled: {"_eq": true}
          }
        }
      }

      var data = await DataServices.getList('organization_account', {"variables": JSON.stringify(variables), "aggregate": "{ aggregate { count } } "});
      var list = data[Object.keys(data)];
      if (list && Object.keys(list).length) {
        count = (list.aggregate.count != undefined && list.aggregate.count != null) ? list.aggregate.count : 0;
      }
      return count;
    }
  }
}
</script>
<style lang="scss">
.box-top-list{border: 1px solid #ccc; padding: 10px; 
  span{font-size: 25px; text-align: left; display: inline-block;}
  .right-button{float: right; 
    span{font-size: 14px;}
    .p-button{border-radius: 5px; min-width: 100px; 
      &.btn-custom{ margin-left: 10px;}
      span{text-align: center;}
    }
  }
}
.box-custom-form { display: flex; padding-top: 0; padding-bottom: 0;
  .item-custom-form{display: inline-flex; align-items: center; padding-top: 0; padding-bottom: 0;
    .title-group-form{font-weight: bold; margin: 0;}
  }
}
.list-data{border: 1px solid #ccc; border-top: 0 none; padding: 20px;
  .p-field{
    .group-label{ position: relative; width: 100%; display: block;
      span{
        &.icon-info{float: right;
          i{background: #AEAEAE; color: #fff; border-radius: 50%; padding: 5px; cursor: pointer;}
          &.selected{
            i{background: #007ad9;}
          }
        }
      }
    }
    .p-field-checkbox{ position: relative;
      label {
        &.group-input-check{position: absolute;
          p{font-style: italic;}
        }
      }
    }
  }
}
.content-confirm {
  p{
    &.text-description { padding: 0 20px;
      span{display: block; margin: 15px 0; font-weight: bold;
        abbr{text-transform: uppercase;}
      }
    }
  }
}

.box_change_role{
  height: 40px;background-color: #1c9bde;border-radius: 5px;display: flex; align-items: center;width: fit-content; padding: 8px;cursor: pointer;
  .img_change_role{
    margin-left: 8px;height: 28px;width: 20px;
  }
  .title_change_role{
    color: #FFFFFF;font-weight: 400;height: fit-content;margin-left: 8px;
  }
}
.dialog-comfirm-common{
  width: 434px;
  .p-dialog-header{
    padding-bottom: 4px; padding-top: 4px;
  }
  .box_body_popup{
    width: 100%;
    .p_title_1{
      text-align: center;margin-bottom: 0px;
    }
    .p_title_2{
      text-align: center;
    }
    .box_btn{
      text-align: center;
      margin-top: 8px;
    }
    .box_title_suceess{
      margin-bottom: 10px;
      .img_noti{
        width: 20px;
        height: 20px;
      }
      .title_noti{
        font-family: 'Arial Bold', 'Arial'; font-weight: 700; font-style: normal; font-size: 18px; color: #009900;margin-left: 8px
      }
    }
    .box_title_err{
      margin-bottom: 10px;
      .img_noti{
        width: 20px;
        height: 20px;
      }
      .title_noti{
        font-family: 'Arial Bold', 'Arial'; font-weight: 700; font-style: normal; font-size: 18px; color: #FF0000;margin-left: 8px
      }
    }
  }
}
</style>